"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRiskControlActionFilterParams = void 0;
var mobx_react_1 = require("mobx-react");
var React = require("react");
var buttons_1 = require("../buttons");
var urls_1 = require("../../urls");
var App_1 = require("../../App");
var filters_1 = require("./filters");
var orderingList_1 = require("./orderingList");
var settings_1 = require("./settings");
var userdefined_1 = require("../../interfaces/userdefined");
var queryStringParser_1 = require("./queryStringParser");
var userDefinedField_1 = require("../userDefinedField");
var config_1 = require("../../config");
var generic_1 = require("../generic");
var riskbimContext_1 = require("../../context/RiskBim/riskbimContext");
var RiskBimMaps_1 = require("../riskPage/RiskBimMaps");
var savedViews_1 = require("../savedViews");
exports.defaultRiskControlActionFilterParams = ("id_status=10&id_status=20" +
    "&id_c_status=10&id_c_status=20&id_c_status=30" +
    "&id_ac_status=10&id_ac_status=20&id_ac_status=30");
var RiskListToolbar = (function (_super) {
    __extends(RiskListToolbar, _super);
    function RiskListToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.savedViewsRef = React.createRef();
        _this.onOrder = function () {
            App_1.store.risklist.fetchData(window.location.search);
        };
        _this.onSaveSettings = function (values) {
            App_1.store.risklist.settings.update(values).then(function () {
                var _a;
                App_1.store.risklist.fetchData(window.location.search);
                (_a = _this.savedViewsRef.current) === null || _a === void 0 ? void 0 : _a.refresh();
            });
        };
        _this.countFilters = function () {
            return _this.state.qs.get_key_count();
        };
        _this.applyHandler = function (event) {
            var paramsString = _this.state.qs.toString();
            window.history.pushState(null, null, window.location.pathname + "?" + paramsString);
            App_1.store.risklist.fetchData("?" + paramsString);
            jQuery('#riskFilterCollapsible').removeClass('show');
        };
        _this.changeHandler = function (name, value) {
            var newState = {};
            if ((0, userdefined_1.isFieldType)(name)) {
                value = value.map(function (udf_value) {
                    if (udf_value.field_type.type_id == userDefinedField_1.UDFTypeChoices.DATE &&
                        !udf_value.field_type.options && udf_value.value != null)
                        udf_value.value = udf_value.value.format(config_1.ISO_DATE_FORMAT);
                    return udf_value;
                });
                var udf_type_1 = name;
                newState["udf_values"] = (_this.state.udf_values
                    .filter(function (udf_value) { return udf_value.field_type.id != udf_type_1.id; })
                    .concat(value));
            }
            else
                newState[name] = value;
            var new_qs = _this.state.qs.clone();
            new_qs.reset_from_state(__assign(__assign({}, _this.state), newState));
            newState['qs'] = new_qs;
            _this.setState(newState);
        };
        _this.handleKeypress = function (e) {
            console.log(e.key);
            if (e.key === 'Enter') {
                $('#apply_button').click();
            }
        };
        _this.onApplyView = function (view) {
            var sep = view.queryString.includes("?") ? "&" : "?";
            var qs = view.queryString + sep + "savedview=" + view.id;
            window.history.pushState(null, null, window.location.pathname + qs);
            App_1.store.risklist.settings.fetchData(qs);
            App_1.store.risklist.fetchData(qs);
        };
        var qs = new queryStringParser_1.QueryStringParser(window.location.search);
        _this.state = {
            qs: qs,
            q: qs.get("q") || "",
            id_status: qs.getAll("id_status"),
            id_owner: qs.getAll("id_owner"),
            t: qs.getAll("t"),
            confidential: qs.getAll("confidential"),
            eval: qs.getAll("eval"),
            reviewed_by: qs.getAll("reviewed_by"),
            reviewed_before: qs.get("reviewed_before"),
            reviewed_after: qs.get("reviewed_after"),
            udf_values: qs.get_udf_fields(),
        };
        return _this;
    }
    RiskListToolbar.prototype.render = function () {
        var _this = this;
        var context = App_1.store.context.get();
        var filter_counter = this.countFilters();
        return (React.createElement("div", { id: "listAccordion" },
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    get_term("Number of risks in current filtering"),
                    ": ",
                    this.props.rows_counter)),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-12" },
                    React.createElement("div", { className: "btn-toolbar mb-3", role: "toolbar", "aria-label": "Toolbar with button groups" },
                        React.createElement("div", { className: "col-6" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "input-group" },
                                    React.createElement("input", { name: "q", type: "text", defaultValue: this.state.qs.get('q'), className: "form-control", placeholder: gettext("Search"), onChange: function (e) { return _this.changeHandler(e.currentTarget.name, e.currentTarget.value); }, onKeyPress: this.handleKeypress }),
                                    React.createElement("div", { className: "input-group-append" },
                                        React.createElement("button", { className: "btn btn-primary btn-block", id: "apply_button", type: "button", onClick: this.applyHandler },
                                            React.createElement("span", { className: "fa fa-search" })))),
                                React.createElement("div", { className: "btn-group", id: "filters_group", role: "group", "aria-label": "Filter, List Settings and Ordering group" },
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "filter", "data-toggle": "collapse", "data-target": "#riskFilterCollapsible", "aria-expanded": "false", "aria-controls": "riskFilterCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.filter }),
                                        " ",
                                        gettext("Filters"),
                                        " ",
                                        filter_counter > 0 && (React.createElement("span", { className: "badge badge-pill badge-primary" }, filter_counter))),
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "setting", "data-toggle": "collapse", "data-target": "#riskSettingsCollapsible", "aria-expanded": "false", "aria-controls": "riskSettingsCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.cog }),
                                        " ",
                                        gettext("List settings")),
                                    React.createElement("button", { type: "button", className: "btn btn-link", id: "ordering", "data-toggle": "collapse", "data-target": "#riskOrderingCollapsible", "aria-expanded": "false", "aria-controls": "riskOrderingCollapsible" },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.sorting }),
                                        " ",
                                        gettext("Ordering"))))),
                        React.createElement("div", { className: "col-6" },
                            React.createElement("div", { className: "row justify-content-end" },
                                React.createElement("div", { className: "btn-group d-none d-lg-inline-flex", id: "list_actions_group", role: "group", "aria-label": "Actions group" },
                                    !this.props.read_only && (React.createElement(buttons_1.ActionButton, { onClick: function (e) { return _this.props.clickHandler(e, (0, urls_1.resolve)(urls_1.Urls.risk_create, context.project), false); } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                                        " ",
                                        get_term("New risk"))),
                                    React.createElement(buttons_1.ActionButton, { onClick: function (event) {
                                            $('#EditableList__BulkButtonId').click();
                                        } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                                        " ",
                                        get_term("Edit risks")),
                                    this.props.has_business_model && !this.props.read_only &&
                                        React.createElement(buttons_1.ActionButton, { onClick: function (e) { return _this.props.clickHandler(e, (0, urls_1.resolve)(urls_1.Urls.import_project, context.project) + "?" + exports.defaultRiskControlActionFilterParams, false); } },
                                            React.createElement(generic_1.Icon, { name: generic_1.Icons.copy }),
                                            " ",
                                            gettext("Copy from project")),
                                    (this.props.has_business_model && this.props.has_bim2d) ?
                                        React.createElement("div", { className: "btn-group", role: "group" },
                                            React.createElement("button", { id: "exports-dropdown", type: "button", className: "btn btn-link dropdown-toggle", "data-toggle": "dropdown", "aria-expanded": "false" },
                                                React.createElement(generic_1.Icon, { name: generic_1.Icons.file_export }),
                                                " ",
                                                gettext("Exports")),
                                            React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "exports-dropdown" },
                                                this.props.has_business_model &&
                                                    React.createElement(buttons_1.ActionButton, { onClick: function (event) { return _this.props.clickExportHandler.bind(_this)(); }, style: buttons_1.ButtonStyles.ACTION },
                                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                                                        " ",
                                                        gettext("Export Excel")),
                                                this.props.has_bim2d &&
                                                    React.createElement("a", { className: "btn btn-link", href: (0, urls_1.resolve)(urls_1.Urls.geo_json_export, context.project) + "?" + this.state.qs.toString(), download: "".concat(this.props.project_title || "Geo Data", ".json") },
                                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.file_code }),
                                                        " ",
                                                        gettext("Export GeoJSON"))))
                                        :
                                            React.createElement(React.Fragment, null,
                                                this.props.has_business_model &&
                                                    React.createElement(buttons_1.ActionButton, { onClick: function (event) { return _this.props.clickExportHandler.bind(_this)(); }, style: buttons_1.ButtonStyles.ACTION },
                                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                                                        " ",
                                                        gettext("Export Excel")),
                                                this.props.has_bim2d &&
                                                    React.createElement("a", { className: "btn btn-link", href: (0, urls_1.resolve)(urls_1.Urls.geo_json_export, context.project) + "?" + this.state.qs.toString(), download: "".concat(this.props.project_title || "Geo Data", ".json") },
                                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.download }),
                                                        " ",
                                                        gettext("Export GeoJSON"))),
                                    this.props.has_bim2d &&
                                        React.createElement("div", { className: "btn-group", role: "group" },
                                            React.createElement("button", { id: "locations-dropdown", type: "button", className: "btn btn-link dropdown-toggle", "data-toggle": "dropdown", "aria-expanded": "false" },
                                                React.createElement(generic_1.Icon, { name: generic_1.Icons.map_with_locations }),
                                                " ",
                                                gettext("Locations")),
                                            React.createElement("div", { className: "dropdown-menu", "aria-labelledby": "locations-dropdown" },
                                                React.createElement(buttons_1.ActionButton, { onClick: this.context.openDialog, style: buttons_1.ButtonStyles.ACTION },
                                                    React.createElement(generic_1.Icon, { name: generic_1.Icons.map_with_locations }),
                                                    " ",
                                                    gettext("Risk Locations")),
                                                React.createElement(buttons_1.ActionButton, { className: "BIMLocationCellButton", onClick: this.context.openDialog },
                                                    React.createElement(generic_1.Icon, { name: generic_1.Icons.map_with_locations }),
                                                    " ",
                                                    gettext("Risk & Control Locations")))),
                                    this.props.has_bim2d &&
                                        React.createElement(RiskBimMaps_1.default, { project_id: context.project, type: 'riskcontrol' })),
                                React.createElement("div", { className: "btn-group d-lg-none", role: "group" },
                                    !this.props.read_only ? (React.createElement(buttons_1.ActionButton, { onClick: function (e) { return _this.props.clickHandler(e, (0, urls_1.resolve)(urls_1.Urls.risk_create, context.project), false); } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.plus_circle }),
                                        " ",
                                        get_term("New risk"))) : (React.createElement(buttons_1.ActionButton, { className: "dropdown-item", onClick: function (event) {
                                            $('#EditableList__BulkButtonId').click();
                                        } },
                                        React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                                        " ",
                                        get_term("Edit risks"))),
                                    React.createElement("button", { type: "button", className: "btn btn-link dropdown-toggle dropdown-toggle-split", "data-toggle": "dropdown", "aria-haspopup": "true", "aria-expanded": "false" },
                                        React.createElement("span", { className: "sr-only" }, "Toggle Dropdown")),
                                    React.createElement("div", { className: "dropdown-menu" },
                                        React.createElement(buttons_1.ActionButton, { className: "dropdown-item", onClick: function (event) {
                                                $('#EditableList__BulkButtonId').click();
                                            } },
                                            React.createElement(generic_1.Icon, { name: generic_1.Icons.edit }),
                                            " ",
                                            get_term("Edit risks")),
                                        this.props.has_business_model && !this.props.read_only &&
                                            React.createElement(buttons_1.ActionButton, { className: "dropdown-item", onClick: function (e) { return _this.props.clickHandler(e, (0, urls_1.resolve)(urls_1.Urls.import_project, context.project) + "?id_status=10&id_status=20&id_c_status=10&id_c_status=20&id_c_status=30&id_ac_status=10&id_ac_status=20&id_ac_status=30", false); } },
                                                React.createElement(generic_1.Icon, { name: generic_1.Icons.copy }),
                                                " ",
                                                gettext("Copy from project")),
                                        this.props.has_business_model &&
                                            React.createElement(buttons_1.ActionButton, { className: "dropdown-item", onClick: function (event) { return _this.props.clickExportHandler.bind(_this)(); }, style: buttons_1.ButtonStyles.ACTION },
                                                React.createElement(generic_1.Icon, { name: generic_1.Icons.file_excel }),
                                                " ",
                                                gettext("Export")))),
                                React.createElement("div", null,
                                    React.createElement(savedViews_1.SavedViewsDropdown, { ref: this.savedViewsRef, projectId: String(context.project), listType: "risk", onApplyView: this.onApplyView }))))))),
            React.createElement("div", { className: "row toolbarCollapsible" },
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "riskFilterCollapsible" },
                    React.createElement(filters_1.RiskFilter, { filter: App_1.store.risklist.filter.data, qs: this.state.qs, include_text: false, onChangeHandler: this.changeHandler }),
                    React.createElement("div", { className: "mb-3" },
                        React.createElement("button", { className: "btn btn-primary btn-block", type: "button", onClick: this.applyHandler }, gettext("Apply")))),
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "riskSettingsCollapsible" },
                    React.createElement(settings_1.default, { settings: App_1.store.risklist.settings.data, save: this.onSaveSettings })),
                React.createElement("div", { className: "col-sm-12 col-md-4 collapse", id: "riskOrderingCollapsible" },
                    React.createElement(orderingList_1.default, { ordering: App_1.store.risklist.data.ordering, onOrder: this.onOrder })))));
    };
    RiskListToolbar.contextType = riskbimContext_1.default;
    RiskListToolbar = __decorate([
        mobx_react_1.observer
    ], RiskListToolbar);
    return RiskListToolbar;
}(React.Component));
exports.default = RiskListToolbar;
